import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Button, TableContainer, Table,
         TableBody, TableRow, TableCell, Typography, IconButton } from "@material-ui/core";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import moment from "moment-timezone";
import t from "../../../languages/pl";
import UploadFileOrTemplate from './../../Common/UploadFileOrTemplate';
import TableHeader from './../../Common/TableHeader';
import { notArrayOrEmpty } from '../../../utils/helpers';
import NoData from './../../Common/NoDataRow';
import guid from './../../../utils/guid';
import { displayDateFormat } from '../../../utils/staticData';
import DaysOffTemplate from "../../../templates/DaysOffTemplate.csv";
import AddHoliday from "./AddHoliday";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import TableContainerWithHeight from './../../Common/TableContainerWithHeight';
import PaperContainer from '../../Common/PaperContainer';

const useStyles = theme => ({
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: theme.spacing(1)
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end"
    },
    cell: {
        padding: theme.spacing(1),
        textAlign: "center"
    }
});

const tableHeader = [t.registrationNo, t.date, t.description, t.delete];

const mapDaysOffFromCsv = (dtin) => ({
    rejestracja: dtin.Rejestracja,
    opis: dtin.Opis,
    data: moment(dtin.Data, "DD.MM.YYYY").unix()
});

const FreeDays = props => {
    const { classes, tableHeight, freeDays, onHolidayAdd, onDelete, allCars, onDataFromFile } = props;
    const [open, setOpen] = useState(false);
    const [dayOffDeleteDialog, setDayOffDeleteDialog] = useState(false);
    const [dayOffId, setDayOffId] = useState(null);

    const onDeleteClick = (id) => {
        setDayOffDeleteDialog(true);
        setDayOffId(id);
    };

    const onConfirmClick = (id) => {
        onDelete(id);
    };

    const handleHolidayAdd = (data) => {
        if(!notArrayOrEmpty(data.auto_id))
            onHolidayAdd && onHolidayAdd(data);
        setOpen(false);
    };

    const handleCsvLoaded = (data) => {
        if(notArrayOrEmpty(data))
            return;
        let newData = data.map(record => {
            let newRecord = mapDaysOffFromCsv(record);
            let car = allCars.find(car => car.rejestracja === newRecord.rejestracja);
            if(!car)
                return;
            return {
                ...newRecord,
                auto_id: car.auto_id
            };
        });
        if(!notArrayOrEmpty(newData))
            onDataFromFile && onDataFromFile(newData);
    };

    const printTable = data => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={4} />;
        return data.map(row => (
            <TableRow key={guid()}>
                <TableCell className={classes.cell}>
                    {row.rejestracja}
                </TableCell>
                <TableCell className={classes.cell}>
                    {moment.unix(row.data).format(displayDateFormat)}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.opis}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton
                        size="small"
                        onClick={() => onDeleteClick(row.wolne_id)}
                    >
                        <DeleteSweepIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <PaperContainer>
            <div className={classes.header}>
                <Typography variant="subtitle1">
                    {t.freeDays}
                </Typography>
                <div className={classes.buttons}>
                     <UploadFileOrTemplate
                        tooltipText={t.importCsvDescriptionFreeDaysTable}
                        template={DaysOffTemplate}
                        onFileLoaded={handleCsvLoaded}
                     />
                     <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setOpen(true)}
                    >
                        {t.add}
                    </Button>
                </div>
            </div>
            <TableContainerWithHeight height={tableHeight - 48 - 16}>
                <Table stickyHeader>
                    <TableHeader data={tableHeader} />
                    <TableBody>
                        {printTable(freeDays)}
                    </TableBody>
                </Table>
            </TableContainerWithHeight>
            <AddHoliday
                open={open}
                onClose={() => setOpen(false)}
                carsAssignable
                title={t.addFreeDay}
                onSubmit={handleHolidayAdd}
            />
            <ConfirmationDialog
                open={dayOffDeleteDialog}
                onClose={() => setDayOffDeleteDialog(false)}
                id={dayOffId}
                onSubmit={(id) => onConfirmClick(id)}
                action={t.deleteDayOffConfirmation}
            />
        </PaperContainer>
    );
};

FreeDays.propTypes = {
    classes: PropTypes.object,
    tableHeight: PropTypes.number,
    freeDays: PropTypes.array,
    allCars: PropTypes.array,
    onHolidayAdd: PropTypes.func,
    onDelete: PropTypes.func,
    onDataFromFile: PropTypes.func
};

export default withStyles(useStyles)(FreeDays);
